export const splitString = (string, size): string[] => {
  var re = new RegExp('.{1,' + size + '}', 'g');

  return string.match(re);
};
